var map = {
	"./en.js": [
		"./src/locales/en.js",
		[]
	],
	"./fr.js": [
		"./src/locales/fr.js",
		[
			76
		]
	],
	"./ja.js": [
		"./src/locales/ja.js",
		[
			4765
		]
	],
	"./ko.js": [
		"./src/locales/ko.js",
		[
			518
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "./src/locales lazy recursive ^\\.\\/.*\\.js$ referencedExports: default";
module.exports = webpackAsyncContext;